/** Binary helpers for E2E (urlsafe base64 without padding). */

export const textEncoder = new TextEncoder();
export const textDecoder = new TextDecoder();

export const concatBytes = (...parts) => {
  const total = parts.reduce((n, p) => n + (p?.length || 0), 0);
  const out = new Uint8Array(total);
  let offset = 0;
  parts.forEach((part) => {
    if (!part || !part.length) return;
    out.set(part, offset);
    offset += part.length;
  });
  return out;
};

export const bytesToB64 = (bytes) => {
  const view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let binary = '';
  for (let i = 0; i < view.length; i += 1) {
    binary += String.fromCharCode(view[i]);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
};

export const b64ToBytes = (value) => {
  const raw = String(value || '').trim().replace(/-/g, '+').replace(/_/g, '/');
  const pad = '='.repeat((4 - (raw.length % 4)) % 4);
  const binary = atob(raw + pad);
  const out = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    out[i] = binary.charCodeAt(i);
  }
  return out;
};

export const randomBytes = (n) => crypto.getRandomValues(new Uint8Array(n));

export const constantTimeEqual = (a, b) => {
  if (!a || !b || a.length !== b.length) return false;
  let diff = 0;
  for (let i = 0; i < a.length; i += 1) {
    diff |= a[i] ^ b[i];
  }
  return diff === 0;
};
